// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","listDiv":"Footer_listDiv__e4OOK"};